export default __webpack_public_path__ + "static/media/hackcuhub.bbfdefef.png";